import {register} from '@shopify/theme-sections'
import '../../styles/sections/contact-us-grid.scss'

function handleChatClick() {
    const chatElement = document.getElementById(`ShopifyChat`) ?? document.getElementById(`dummy-chat-button-iframe`)
    if (chatElement) {
        chatElement.contentDocument.querySelector(`[aria-label="Chat window"]`).click()
    }
}

export default register(`contact-us-grid`, {
    onLoad() {
        if (document.querySelector(`[data-chat]`)) {
            document.querySelector(`[data-chat]`).addEventListener(`click`, handleChatClick)
        }
    },

    onUnload() {
        if (document.querySelector(`[data-chat]`)) {
            document.querySelector(`[data-chat]`).removeEventListener(`click`, handleChatClick)
        }
    }
})
